module.exports = __webpack_public_path__ + "media/fonts/Oswald-Regular-3050581782456ed4faf7ddc9d005ba2a.woff2";